import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsuranceBicycleModule } from '../insurance-bicycle/insurance-bicycle.module';
import { InsuranceCarModule } from '../insurance-car/insurance-car.module';
import { InsuranceCaravanModule } from '../insurance-caravan/insurance-caravan.module';
import { InsuranceEndProductComponent } from '../insurance-end-product';
import { InsuranceHomeModule } from '../insurance-home/insurance-home.module';
import { InsuranceIMICModule } from '../insurance-imic/insurance-imic.module';
import { InsuranceMopedModule } from '../insurance-moped/insurance-moped.module';
import { InsuranceMotorcycleModule } from '../insurance-motorcycle/insurance-motorcycle.module';
import { InsurancePetModule } from '../insurance-pet/insurance-pet.module';
import { InsuranceRegularDriverModule } from '../insurance-regular-driver/insurance-regular-driver.module';
import { InsuranceDetailComponent } from './insurance-detail.component';
import { InsurancePremiumDeterminingFactorsComponent } from '../insurance-premium-determining-factors';
import { InsuranceCoverageComponent } from '../insurance-coverage';
import { InsuranceStartDateComponent } from '../insurance-start-date';
import { InsuranceTermsAndConditionsComponent } from '../insurance-terms-and-conditions';
import { WucCardModule, WucRackModule } from '@inshared/website-ui-components';

@NgModule({
    imports: [
        CommonModule,
        InsuranceIMICModule,
        InsuranceRegularDriverModule,
        InsuranceCoverageComponent,
        InsuranceEndProductComponent,
        InsuranceBicycleModule,
        InsuranceCarModule,
        InsuranceCaravanModule,
        InsuranceHomeModule,
        InsuranceMopedModule,
        InsuranceMotorcycleModule,
        InsurancePetModule,
        InsuranceTermsAndConditionsComponent,
        WucCardModule,
        InsuranceStartDateComponent,
        InsurancePremiumDeterminingFactorsComponent,
        WucRackModule,
    ],
    exports: [InsuranceDetailComponent],
    declarations: [InsuranceDetailComponent],
})
export class InsuranceDetailModule {}
